import { render, staticRenderFns } from "./makeAnswerExam.vue?vue&type=template&id=24bfaaa5&scoped=true"
import script from "./makeAnswerExam.vue?vue&type=script&lang=js"
export * from "./makeAnswerExam.vue?vue&type=script&lang=js"
import style0 from "./makeAnswerExam.vue?vue&type=style&index=0&id=24bfaaa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bfaaa5",
  null
  
)

export default component.exports